import { render } from "./RiLnbProduct.vue?vue&type=template&id=59b87dbc"
import script from "./RiLnbProduct.vue?vue&type=script&lang=js"
export * from "./RiLnbProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiLnbProduct.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59b87dbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59b87dbc', __exports__)) {
    api.reload('59b87dbc', __exports__)
  }
  
  module.hot.accept("./RiLnbProduct.vue?vue&type=template&id=59b87dbc", () => {
    api.rerender('59b87dbc', render)
  })

}


export default __exports__